<div class="container">
  <div class="row">
    <div class="col-lg-3 col--flex">
      <wired-shortcut-menu [subscription]="subscription()" [activities]="activities()"></wired-shortcut-menu>
    </div>

    <div class="col-lg-9">
      <div class="card">
        <subscription-detail-header
          [subscription]="subscription()"
          [showReportIncidentButton]="isCurrentOrganisation()"
        />
        <div class="row">
          <div class="col-12 col-sm-7">
            <table class="table-properties table-properties--no-margin">
              <tr>
                <td>{{ "ServiceElement.Owner" | translate }}</td>
                <td>{{ owner() }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.OwnAlias" | translate }}</td>
                <td>
                  <alias-editor [customerDescription]="customerDescription()" [subscriptionId]="subscriptionId()" />
                </td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.SURFnetDescription" | translate }}</td>
                <td>{{ description() }}</td>
              </tr>
            </table>
          </div>
          <div class="col-12 col-sm-5">
            <table class="table-properties table-properties--no-margin">
              @if (isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.Status" | translate }}</td>
                  <td>{{ status() }}</td>
                </tr>
              }
              <tr>
                <td>{{ "ServiceElement.Start" | translate }}</td>
                <td>{{ startDate() | subscription_date }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.MonitoringEnabled" | translate }}</td>
                <td>{{ monitoringEnabled() }}</td>
              </tr>
              @if (customCustomerAbbreviation()) {
                <tr>
                  <td>{{ "ServiceElement.CustomCustomerAbbreviation" | translate }}</td>
                  <td>{{ customCustomerAbbreviation() }}</td>
                </tr>
              }
              @if (isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.End" | translate }}</td>
                  <td>{{ endDate() | subscription_date }}</td>
                </tr>
              }
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (isTerminated()) {
    <div class="hide-everything-after-this-div"></div>
  }
  <hr />
  <hr />
  <hr />
  <div>
    <devices-section [subscriptionId]="subscriptionId()" />
    <alerts-section [subscriptionId]="subscriptionId()" />
  </div>
</div>
